'use strict';
/* generated by gulpfile.js */
export default () => {
  return [
    '<input>',
    'alwaysShowCalendars',
    'applyClass',
    'autoApply',
    'autoUpdateInput',
    'buttonClasses',
    'cancelClass',
    'dateLimit',
    'drops',
    'endDate',
    'isCustomDate',
    'isInvalidDate',
    'linkedCalendars',
    'locale',
    'maxDate',
    'minDate',
    'opens',
    'parentEl',
    'ranges',
    'maxSpan',
    'showCustomRangeLabel',
    'showDropdowns',
    'showISOWeekNumbers',
    'showWeekNumbers',
    'singleDatePicker',
    'startDate',
    'template',
    'timePicker',
    'timePicker24Hour',
    'timePickerIncrement',
    'timePickerSeconds'
  ];
};